import { render, staticRenderFns } from "./semDoublePage.vue?vue&type=template&id=ddb02290&"
import script from "./semDoublePage.vue?vue&type=script&lang=js&"
export * from "./semDoublePage.vue?vue&type=script&lang=js&"
import style0 from "./semDoublePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports